import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_icon = _resolveComponent("s-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_s_icon, _mergeProps(_ctx.computedProps, {
      size: _ctx.size,
      tooltip: _ctx.showTooltip ? _ctx.computedProps.tooltip : undefined
    }), null, 16, ["size", "tooltip"]),
    (_ctx.showText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["status-badge", _ctx.type])
        }, _toDisplayString(_ctx.computedProps.tooltip), 3))
      : _createCommentVNode("", true)
  ], 64))
}